import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { ClientSOC, StartOfCareBO, EditSOCDetails, functionpermission, SOCListBO, authpermission } from '../client-parent.model';
import { DataStateChangeEventArgs, FilterSettingsModel } from '@syncfusion/ej2-grids';
import { GridComponent, IFilter, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DataUtil } from '@syncfusion/ej2-data';
import { ToastrService } from 'ngx-toastr';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { ColumnChangeBO, columnWidth } from '../../list/list.model';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
  selector: 'app-startofcarelist',
  templateUrl: './startofcarelist.component.html',
  styleUrls: ['./startofcarelist.component.scss'],
})
export class StartofcarelistComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  Lsoclist: ClientSOC[];
  fp: authpermission = new authpermission()

  filterOptions: FilterSettingsModel;
  initialPage: object;
  @ViewChild('grid') public grid: GridComponent;
  filter: IFilter;
  deleteId: number;
  public data: Observable<DataStateChangeEventArgs>;
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  ListBO: SOCListBO = new SOCListBO();
  public formatOptions: object;
  @Output() EventToEditSOC = new EventEmitter<EditSOCDetails>();
  EditOptions: EditSOCDetails = new EditSOCDetails();
  SOCTotalColumns:number=6;

  constructor(public CommonAPI: CommonApiService, public global: GlobalComponent,public toastrService: ToastrService, private ref: ChangeDetectorRef, 
  ) {
    this.data = CommonAPI;
  }
  ngOnInit(): void {
    this.clearGridLocalStorage();
    this.filterOptions = { type: 'Menu' };
    this.filter = {
      type: 'Excel'
    };
    // let pag = JSON.parse(this.global.globalColumn.column)[0].Startofcare.Pagesize;
    let pag = 10;
    this.initialPage = { pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: pag };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.ListBO.pageitem = pag;
    this.getSOClist();
    this.getpermission()
  }

  //=======================================Get soc list===============================//
  getSOClist() {
    this.ListBO.clientId = this.global.clientId;
    let url ="api/StartOfCare/GetStartOfCareList"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.CommonAPI.outputValues(url, this.ListBO, responseData, "");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
      count++;
      this.Lsoclist = DataUtil.parse.parseJson(datas.result);

      if (datas != null && datas != undefined && count == 1) {
        setTimeout(() => 100);

      }
    });
  }
  //=======================================Create/update modal soc list===============================//
  AddStartofcare(modalType: string) {
    console.log(modalType,"modalType")
    if (modalType == 'new') {
      this.EditOptions.isEdit = true;
      this.EditOptions.isEditSOC = false;
      this.EventToEditSOC.emit(this.EditOptions);
    }
    if (modalType == 'edit') {
      this.EditOptions.isEdit = true;
      this.EditOptions.isEditSOC = true;
      this.EventToEditSOC.emit(this.EditOptions);
    }
    if (modalType == 'delete') {
      this.EditOptions.isEdit = true;

      this.EditOptions.type = "delete";
      this.EventToEditSOC.emit(this.EditOptions);
    }

  }
  //=============================================Datatoedit======================//
  Datatoedit(data: StartOfCareBO) {
    this.EditOptions.clientSOCData = data;
    this.EditOptions.clientId = data.clientId;
  }
  getpermission() {
    let params = new URLSearchParams();
    params.append("pagecode", "Client");
   // params.append("agencyId", this.global.agencyId);
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new authpermission();
      }
    },
      (err: any) => {
        this.fp = new authpermission();
      })
  }



  //============================== Tooltip =========================================================//
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',


        }, args.cell as HTMLTableCellElement);
      }
    }
  }


  // ==============================================================================

  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
     }
  }


  //========================= evnt change =====================================================================//
  public dataStateChange(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListBO.orderColumn = "CompanyName";
        this.ListBO.orderType = 'asc';

      }
    }
    if (this.ListBO.type == "date") {
      this.ListBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
      this.ListBO.field = state.action.currentFilterObject.field;
    }

    if (val == "filtering" && state.action.action != "clearFilter") {
      this.ListBO.field = state.action.currentFilterObject.field;
      this.ListBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListBO.operator = state.action.currentFilterObject.operator;
      this.ListBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.ListBO.field = "CompanyName";
        this.ListBO.matchCase = false;
        this.ListBO.operator = "contains";
        this.ListBO.value = "";
        this.ListBO.type = "string"
        this.ListBO.clientId = this.global.clientId;
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Startofcare.Pagesize != state.take) {
          this.arraycol[0].Startofcare.Pagesize = state.take
        }
      }
    }
    this.getSOClist();
  }

  /////////////////////////////Action Begin ////////////////////////////////////////////////////////

  public onActionComplete(args) {


    this.ListBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;

    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ListBO.type = args.columnType
    }

  }
  clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridSOCGrid', expectedColumns: this.SOCTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}